export default "__VITE_ASSET__bbb84992__"